import * as styles from '@classification-testing/components/ClassificationResultItem.css';
import type { ClassificationResult } from '@classification-testing/domain';
import { formatTimestamp } from '@core/utils';
import { Text, IconButton, IconButtonSize, IconSize, Eye, StatusCircleBlock } from '@soteria/design-system-ve';

interface ClassificationCardControlsProps {
  result: ClassificationResult;
  isSafe: boolean;
  isContentBlurred: boolean;
  onToggleBlur: (e: React.MouseEvent) => void;
}

/**
 * Controls section with blur toggle and timestamp
 */
export function ClassificationCardControls({ result, isSafe, isContentBlurred, onToggleBlur }: ClassificationCardControlsProps) {
  return (
    <div className={styles.metadataRightSection}>
      {!isSafe && (
        <IconButton
          aria-label={isContentBlurred ? 'Show content' : 'Hide content'}
          buttonSize={IconButtonSize.Small}
          icon={isContentBlurred ? Eye : StatusCircleBlock}
          iconSize={IconSize.Small}
          title={isContentBlurred ? 'Show content' : 'Hide content'}
          onClick={onToggleBlur}
        />
      )}
      <Text className={styles.timestamp}>{formatTimestamp(result.timestamp)}</Text>
    </div>
  );
}
